module.exports = __webpack_public_path__ + "static/media/success-bg.f462b8f1.png";